import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-account-number-dialog',
  templateUrl: './account-number-dialog.component.html',
  styleUrls: ['./account-number-dialog.component.scss']
})
export class AccountNumberDialogComponent implements OnInit {
  @Input() defaultNumber!: string;
  @Input() validationMask!: RegExp;
  @Input() editMask!: string;
  @Input() helpText!: string;

  form = new FormGroup({
    accountNumber: new FormControl('')
  });

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.validationMask) {
      this.form.controls['accountNumber'].setValidators([Validators.required, Validators.pattern(this.validationMask)]);
    } else {
      this.form.controls['accountNumber'].setValidators([Validators.required]);
    }
    this.form.controls['accountNumber'].setValue(this.defaultNumber || '');
  }

  save() {
    if (this.form.valid) {
      this.activeModal.close(this.form.controls['accountNumber'].value);
    }
  }

  cancel() {
    // Close with a sentinel value so the opener can treat this as a user-cancel
    this.activeModal.close(ACCOUNT_NUMBER_DIALOG_CANCEL);
  }
}

export const ACCOUNT_NUMBER_DIALOG_CANCEL = '__ACCOUNT_NUMBER_DIALOG_CANCEL__';

